import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import FormControl from "react-bootstrap/FormControl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { campaignFetcher, subscribersFetcher } from "../../api/requests";
import { useToaster } from "../../context/toaster";
import { useState, useContext, useEffect } from "react";
import { ProfileContext } from "../../context/profile";
import { useLocation, useHistory } from "react-router-dom";
import { AuthContext } from "../../context/auth";
import NavDropdown from "react-bootstrap/NavDropdown";
import { baseURL } from "../../api/dataFetcher";
import LoadingIndicator from "../Atomics/Loading/Loading";

export default function SingleChannelNav({
  channel,
  setNavOption,
  navOption,
  campaign,
  showRelatedChannels,
  setSearchText,
}) {
  const { addMessage } = useToaster();
  const [subscribed, setSubscribed] = useState(false);
  const { profile } = useContext(ProfileContext);
  const [subscription, setSubscription] = useState();
  const location = useLocation();
  const campaignId = new URLSearchParams(location.search).get("campaign");
  const { user } = useContext(AuthContext);
  const history = useHistory();
  const [subscribers, setSubscribers] = useState([]);
  const [subscribersLoading, setSubscribersLoading] = useState(true);
  const [isSubscribeLoading, setIsSubscribeLoading] = useState(false);

  const handleNavClick = (value) => {
    setNavOption(value);
  };

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const handleSubscribe = async () => {
    if (!user.user_id) {
      history.push("/auth/login/");
      return;
    }

    try {
      setIsSubscribeLoading(true);
      if (subscribed) {
        const res = campaignId
          ? await campaignFetcher.unsubscribe(subscription?.results[0].id)
          : await subscribersFetcher.unsubscribe(subscription?.results[0].id);
        // if (res) {
        showToast("success", "لغو اشتراک با موفقیت انجام شد.");
        setSubscribed(false);
        setSubscription(null);
        // }
      } else {
        const res = campaignId
          ? await campaignFetcher.subscribe(channel?.id)
          : await subscribersFetcher.subscribe(channel?.id);
        if (res) {
          showToast("success", "با موفقیت عضو شدید.");
          setSubscribed(true);
          const updatedSubscriptionData = campaignId
            ? await campaignFetcher.isSubscribed(profile.user, channel.id)
            : await subscribersFetcher.isSubscribed(profile.user, channel.id);
          setSubscription(updatedSubscriptionData);
        }
      }
    } catch (error) {
      showToast(
        "error",
        Object.values(error.response?.data)[0] ??
          "خطایی رخ داده است، دوباره تلاش کنید."
      );
    } finally {
      setIsSubscribeLoading(false);
    }
  };

  const getSubscribers = async () => {
    setSubscribersLoading(true);
    try {
      const res = campaign
        ? await campaignFetcher.getCampaignsSubscriptions(channel?.id)
        : await subscribersFetcher.getChannelsSubscriptions(channel?.id);
      setSubscribers(res.results || []);
    } catch (err) {
      console.error(err);
      setSubscribers([]);
    } finally {
      setSubscribersLoading(false);
    }
  };

  useEffect(() => {
    const checkSubscription = async () => {
      if (profile.user && channel?.id) {
        setIsSubscribeLoading(true);
        try {
          const subscriptionData = campaignId
            ? await campaignFetcher.isSubscribed(profile.user, channel.id)
            : await subscribersFetcher.isSubscribed(profile.user, channel.id);
          setSubscribed(subscriptionData?.count > 0);
          setSubscription(subscriptionData);
        } catch (error) {
          console.error("Error checking subscription:", error);
          setSubscribed(false);
        } finally {
          setIsSubscribeLoading(false);
        }
      }
    };

    checkSubscription();
  }, [profile.user, channel?.id]);

  useEffect(() => {
    if (!channel?.id) return;
    getSubscribers();
  }, [channel?.id]);

  return (
    <>
      <div className="single-channel-nav">
        <Navbar expand="lg">
          <div style={{ display: "flex" }} className="navBarMenu">
            <div style={{ display: "flex", alignItems: "center" }}>
              <Navbar.Brand className="channel-brand pr-1">
                {channel?.name} {/*<VerifiedTooltip />*/}
              </Navbar.Brand>
              {channel?.subscribe_count > 0 ? (
                <NavDropdown
                  align="end"
                  title={
                    <strong>{channel?.subscribe_count} عضو &nbsp;&nbsp;</strong>
                  }
                  className="subscribers"
                >
                  {subscribersLoading ? (
                    <LoadingIndicator />
                  ) : subscribers?.length > 0 ? (
                    subscribers.map((subscriber, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          gap: "5px",
                          padding: "5px",
                          alignItems: "center",
                          borderBottom:
                            index < subscribers.length - 1
                              ? "1px dashed gray"
                              : "",
                          maxWidth: "240px",
                        }}
                      >
                        <img
                          src={
                            subscriber?.user?.image
                              ? baseURL + subscriber.user.image
                              : "/img/s1.png"
                          }
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                          alt={`${subscriber?.user?.first_name} ${subscriber?.user?.last_name}`}
                        />
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <span style={{ direction: "ltr", fontSize: "14px" }}>
                            {subscriber.user.username}
                          </span>
                          <span style={{ direction: "ltr", fontSize: "14px" }}>
                            {(!/[\d]/.test(subscriber.user.first_name) &&
                            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                              subscriber.user.first_name
                            )
                              ? subscriber.user.first_name
                              : "") +
                              " " +
                              (!/[\d]/.test(subscriber.user.last_name) &&
                              !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                                subscriber.user.last_name
                              )
                                ? subscriber.user.last_name
                                : "")}
                          </span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <LoadingIndicator />
                  )}
                </NavDropdown>
              ) : (
                <strong>{channel?.subscribe_count} عضو &nbsp;&nbsp;</strong>
              )}
            </div>

            <Navbar.Toggle aria-controls="navbarSupportedContent" />
            <Navbar.Collapse id="navbarSupportedContent">
              <Nav as="ul" className="mr-auto">
                <li
                  className={`nav-item ${navOption === "videos" && "active"}`}
                  onClick={() => handleNavClick("videos")}
                >
                  <span style={{ cursor: "pointer" }} className="nav-link">
                    ویدئوها
                  </span>
                </li>
                {showRelatedChannels ? (
                  <li
                    className={`nav-item ${
                      navOption === "relatedChannels" && "active"
                    }`}
                    onClick={() => handleNavClick("relatedChannels")}
                  >
                    <span style={{ cursor: "pointer" }} className="nav-link">
                      کانال های هم سو
                    </span>
                  </li>
                ) : (
                  ""
                )}

                {!campaign && (
                  <li
                    className={`nav-item ${
                      navOption === "playlist" && "active"
                    }`}
                    onClick={() => handleNavClick("playlist")}
                  >
                    <span style={{ cursor: "pointer" }} className="nav-link">
                      لیست پخش
                    </span>
                  </li>
                )}

                <li
                  className={`nav-item ${navOption === "about" && "active"}`}
                  onClick={() => handleNavClick("about")}
                >
                  <span style={{ cursor: "pointer" }} className="nav-link">
                    درباره {campaign ? "پویش" : "کانال"}
                  </span>
                </li>
              </Nav>
            </Navbar.Collapse>
          </div>
          <Form
            onSubmit={(e) => e.preventDefault()}
            inline
            className=" my-2 my-lg-0 navBarForm"
          >
            <FormControl
              type="text"
              placeholder="جستجو"
              className="mr-sm-1"
              size="sm"
              onChange={(e) => setSearchText(e.target.value)}
            />
            <Button
              variant="outline-info"
              size="sm"
              className="my-2 my-sm-0"
              style={{ cursor: "default" }}
            >
              <FontAwesomeIcon icon={faSearch} />
            </Button>
            &nbsp;&nbsp;&nbsp;
            <Button onClick={handleSubscribe} variant="outline-info" size="sm">
              {isSubscribeLoading ? (
                <LoadingIndicator size="sm" padding="2px" />
              ) : subscribed ? (
                "عضو هستید"
              ) : (
                "عضو شوید"
              )}
            </Button>
          </Form>
        </Navbar>
      </div>
    </>
  );
}
